/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlNotifyZeroDayAlertClientsResponse
 */
export interface ControlNotifyZeroDayAlertClientsResponse {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ControlNotifyZeroDayAlertClientsResponse
     */
    notified_emails: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the ControlNotifyZeroDayAlertClientsResponse interface.
 */
export function instanceOfControlNotifyZeroDayAlertClientsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notified_emails" in value;

    return isInstance;
}

export function ControlNotifyZeroDayAlertClientsResponseFromJSON(json: any): ControlNotifyZeroDayAlertClientsResponse {
    return ControlNotifyZeroDayAlertClientsResponseFromJSONTyped(json, false);
}

export function ControlNotifyZeroDayAlertClientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlNotifyZeroDayAlertClientsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notified_emails': json['notified_emails'],
    };
}

export function ControlNotifyZeroDayAlertClientsResponseToJSON(value?: ControlNotifyZeroDayAlertClientsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notified_emails': value.notified_emails,
    };
}

